export enum CollectionType {
  Whishlist = "Whishlist",
  Storefront = "Storefront",
}
